/**
 * ActionSheet组件
 */

import {show as showActionSheet} from '../components/ActionSheet';
import {supportNative, getErrorFactory, logError} from './util';

const zzc = window.zzc;


/**
 * 显示ActionSheet组件
 *
 * @export
 * @param {object} options 参数
 * title: propTypes.node,
 * options: propTypes.array.isRequired,
 * cancelIndex: propTypes.number,
 * destroyIndex: propTypes.number,
 * callback: propTypes.func.isRequired
 */
export function show(options) {
  let errorFactory = getErrorFactory('ActionSheet.show');
  let callback = options.callback;

  options.callback = function (index) {
    callback && callback(index);
  };

  if (supportNative('base_showNativeActionSheet')) {
    zzc.call('base_showNativeActionSheet', {
      title: options.title,
      options: options.options,
      destructiveButtonIndex: options.destroyIndex,
      cancelButtonIndex: options.cancelIndex,
      complete: function (res) {
        if (res.state) {
          logError(errorFactory(res.message));
        } else {
          options.callback(res.data);
        }
      }
    });
  } else {
    showActionSheet(options);
  }
}



// WEBPACK FOOTER //
// ./src/native/ActionSheet.js